var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-entity",
    _vm._l(_vm.pages, function (_page) {
      return _c(
        "a-entity",
        { key: _page.id },
        _vm._l(_page.linkspots, function (_linkspot) {
          return _c("link-spot", {
            key: _linkspot.id,
            attrs: {
              id: "_linkspot" + _linkspot.id,
              scale: _vm.page && _vm.page.id === _page.id ? "1 1 1" : "0 0 0",
              linkspot: _linkspot,
            },
          })
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }